/**
 * Base ActionFlowRequestDTO skeleton for the Flow Simulator.
 * valueData / changesData / beforeData are overridden at runtime
 * with real customer and product data from useFlowSimulatorData.
 */
export const MOCK_ACTION_FLOW_DATA = {
    id: 'sim-00000001',
    domain: 'LOAN_APPLICATION',
    subscriptionId: 'sim-subscription',
    state: 'LOAN_OFFICER',
    approvalAction: '',
    approvalComment: '',
    approvalActions: [
        { value: 'LOAN_OFFICER_APPROVE', label: 'Approve' },
        { value: 'LOAN_OFFICER_REJECT',  label: 'Reject' },
        { value: 'LOAN_OFFICER_RETURN',  label: 'Return to Maker' },
    ],
    valueData: {},
    changesData: {},
    beforeData: {},
};
